import { Block, State } from "../../types";

export type PaginateAction = Readonly<{
  up: boolean;
  type: "PAGINATE";
}>;

export const paginate = (state: State, action: PaginateAction): State => {
  let newCurrentPage = action.up ? state.currentPage + 1 : state.currentPage - 1;

  const activeBlockOrder = GetCanvasBlockOrder(state, newCurrentPage * state.pageSize, (newCurrentPage+1) * state.pageSize);
  const activeBlocks = GetCanvasBlocks(state, newCurrentPage * state.pageSize, (newCurrentPage+1) * state.pageSize);
  return {
    ...state,
    currentPage : newCurrentPage,
    activeBlockOrder,
    activeBlocks,
  };
};

export const GetCanvasBlockOrder = (state: State, canvasPageStart: number, canvasPageEnd: number): Array<string> => {
  const blockOrder: Array<string> = [];
  for (let i = 0; i < state.blockOrder.length; i++) {
    const block = state.blocks[state.blockOrder[i]];
    if (block.page >= canvasPageStart && block.page < canvasPageEnd) {
      blockOrder.push(state.blockOrder[i]); 
    }
  }
  return blockOrder;
};

export const GetCanvasBlocks = (state: State, canvasPageStart: number, canvasPageEnd: number): { [blockId: string]: Block } => {
  const blocks: { [blockId: string]: Block } = {};
  for (let i = 0; i < state.blockOrder.length; i++) {
    const block = state.blocks[state.blockOrder[i]];
    if (block.page >= canvasPageStart && block.page < canvasPageEnd) {
      blocks[block.id] = {
        ...block,
        page: block.page - canvasPageStart
      };
    }
  }
  return blocks;
};